'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["mode", "onModeChange", "onUpdate"];
import PropTypes from 'prop-types';
import { CSSTransitionGroup as CSSTransition } from 'react-transition-group';
import { KeyTypes, PopoverBodyMode } from '../../constants/popover';
import AnchorPopoverBodyEdit from './AnchorPopoverBodyEdit';
import AnchorPopoverBodyLite from './AnchorPopoverBodyLite';
import { jsx as _jsx } from "react/jsx-runtime";
const propTypes = {
  mode: PropTypes.oneOf(Object.values(PopoverBodyMode)),
  onModeChange: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired
};
function AnchorPopoverBodyBranch(props) {
  const {
      mode,
      onModeChange,
      onUpdate
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const handleClose = () => {
    onModeChange(PopoverBodyMode.PREVIEW);
  };
  const handleEdit = () => {
    onModeChange(PopoverBodyMode.EDIT);
  };
  const handleSave = anchorId => {
    handleClose();
    onUpdate(anchorId);
  };
  const handleKeyDown = evt => {
    if (evt.key === KeyTypes.ESCAPE) {
      handleClose();
    }
  };
  return /*#__PURE__*/_jsx("div", {
    className: "animated-popover-body",
    onKeyDown: handleKeyDown,
    tabIndex: "-1",
    children: /*#__PURE__*/_jsx(CSSTransition, {
      className: "animated-transition",
      transitionName: "animated-popover",
      transitionEnterTimeout: 100,
      transitionLeaveTimeout: 100,
      children: mode === PopoverBodyMode.PREVIEW ? /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(AnchorPopoverBodyLite, Object.assign({}, rest, {
          onEdit: handleEdit
        }))
      }, 0) : /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(AnchorPopoverBodyEdit, Object.assign({}, rest, {
          onSave: handleSave,
          onClose: handleClose
        }))
      }, 1)
    })
  });
}
AnchorPopoverBodyBranch.propTypes = propTypes;
AnchorPopoverBodyBranch.displayName = 'AnchorPopoverBodyBranch';
export default AnchorPopoverBodyBranch;